<template>
  <div>
    <h3 class="related-news--title" v-if="title">{{ title }}</h3>
    <sui-loader v-show="fetching" size="large" active centered inline />
    <h4 v-show="!fetching && items.length === 0" class="related-news--no-results">
      <p v-html="$t('contact.vacanciesnotfound')"></p>
    </h4>
    <div :class="['related-news']">
      <arrow-slider
        v-show="!fetching && items.length > 0"
        class="related-news__arrow-slider"
        @click="nextSlide"
      />
      <slick
        ref="slick"
        :options="slickOptions"
        class="related-news__slider"
        v-if="items.length > 0 && !fetching"
      >
        <related-news-item
          v-for="(slide, index) in items"
          :key="`${slide.title}-${index}`"
          :title="slide.title"
          :description="slide.short_content || slide.description"
          theme="text-only"
          :buttonText="buttonText"
          :city="slide.regional_name"
          :linkExternal="linkExternal"
          :link="slide.link"
          :isVacancies="isVacancies"
        />
      </slick>
    </div>
  </div>
</template>

<script>
import Slick from "vue-slick";
import RelatedNewsItem from "../related-news-item";
import ArrowSlider from "@/assets/arrow-slider.svg";

export default {
  name: "related-news",

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    theme: {
      type: String,
      default: "default",
    },
    title: {
      type: String,
      default: "Recent News",
    },
    buttonText: {
      type: String,
      default: "Read more",
    },
    city: {
      type: String,
      default: "",
    },
    linkExternal: {
      type: Boolean,
      default: false,
    },
    fetching: {
      type: Boolean,
      default: true,
    },
    isVacancies: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    Slick,
    "arrow-slider": ArrowSlider,
    "related-news-item": RelatedNewsItem,
  },

  data() {
    return {
      slickOptions: {
        slidesToShow: 2,
        variableWidth: true,
        arrows: false,
        infinite: true,
        speed: 900,
        cssEase: "cubic-bezier(.15,.22,.6,.9)",
        responsive: [
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: 1,
              variableWidth: true,
            },
          },
        ],
      },
    };
  },

  watch: {
    items() {
      if (this.$refs.slick) {
        this.$refs.slick.destroy();
        this.$nextTick(() => {
          this.$refs.slick.create();
          this.$refs.slick.setOption(this.slickOptions);
          this.$refs.slick.setPosition();
        });
      }
    },
  },

  methods: {
    nextSlide() {
      this.$refs.slick.next();
    },
  },
};
</script>

<style lang="scss">
.related-news {
  height: auto;
  width: 95%;
  left: 20%;
  padding: 0;
  position: relative;
  display: flex;
  justify-content: flex-end;
  padding: 30px;

  &--no-results {
    font-size: 25px;
    font-weight: 300;
    text-align: center;
  }

  &--title {
    width: 95%;
    left: 20%;
    position: relative;
    padding-left: 25px;
    font-size: 23px;
    font-weight: 300;
    margin-bottom: 15px;
    font-family: $david;
  }

  &__slider {
    display: flex;
    position: relative;
  }

  .slick-track {
    display: flex;
    overflow: hidden;
    width: 100%;
  }

  .slick-slider {
    display: flex;
    overflow: hidden;
    width: 100%;
    justify-content: flex-end;
  }

  .slick-list {
    position: relative;
    overflow: hidden;
    width: 100%;
  }

  .slick-slider .slick-track,
  .slick-slider .slick-list {
    -webkit-perspective: 1000px;
    perspective: 1000px;
  }

  .slick-slide {
    margin-left: 0;
    width: 33vw !important;
    overflow: hidden;
    -webkit-transform: translate3d(0, 0, 0);
    -webkit-backface-visibility: hidden;
    transition: opacity 0.3s ease-out;
    outline: none;
  }

  &__arrow-slider {
    position: absolute;
    top: 0;
    bottom: 0;
    left: -18%;
    margin: auto;
    width: 80px;
    height: 80px;
    cursor: pointer;
    transition: all 0.3s ease-out;
    opacity: 1;

    image {
      width: 80px;
      height: 80px;
    }

    &:hover {
      opacity: 0.5;
      transition: opacity 0.3s ease-in-out;
    }
  }
}

@media (max-width: 1300px) {
  .related-news {
    .slick-slide {
      margin-left: 30px;
    }
  }
}

@media (max-width: 1000px) {
  .related-news {
    padding: 20px;

    &--title {
      width: 95%;
      position: relative;
      padding-left: 18px;
      font-size: 23px;
      font-weight: 300;
      margin-bottom: 15px;
    }

    .slick-slide {
      width: 85vw !important;
      margin-left: 0;
    }

    &__arrow-slider {
      width: 40px;
      height: 40px;
      left: -18%;

      image {
        width: 40px;
        height: 40px;
      }

      &:hover {
        left: -19%;
      }
    }
  }
}

@media (max-width: 400px) {
  .related-news {
    padding: 20px;

    &__arrow-slider {
      width: 40px;
      height: 40px;
      left: -15%;

      image {
        width: 40px;
        height: 40px;
      }
    }
  }
}
</style>
